import { type PropsWithChildren, createContext, useContext, useMemo } from 'react'

import { useEntitiesContext } from 'entities/EntitiesExport'
import { SavedRepliesStore } from 'pages/settings/pages/savedReplies/store/SavedRepliesStore'

const SavedRepliesContext = createContext<SavedRepliesStore | null>(null)

export const useSavedRepliesContext = () => {
  const context = useContext(SavedRepliesContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with SavedRepliesProvider')

  return context
}

export const SavedRepliesProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new SavedRepliesStore(entities), [])

  return <SavedRepliesContext.Provider value={store}>{children}</SavedRepliesContext.Provider>
}
